.wrapper {
    position: relative;
    width: 100%;
}

/*
 * Thin progress bar pinned beneath the call controls bar. The track sits flush against the
 * bottom edge of the bar and spans the full visible width (matching the .controlsContainer
 * horizontal padding via negative left/right offsets).
 *
 * Fades in smoothly when pacing data becomes available, and the fill grows from left to
 * right as elapsed time approaches the configured target.
 */
.track {
    position: absolute;
    top: 100%;
    left: calc(-1 * var(--mantine-spacing-sm));
    right: calc(-1 * var(--mantine-spacing-sm));
    height: 4px;
    background-color: color-mix(in srgb, var(--mantine-color-dark-4) 60%, transparent);
    overflow: hidden;
    pointer-events: none;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.4s ease;
}

.trackVisible {
    opacity: 1;
}

.fill {
    height: 100%;
    width: 0%;
    background-color: transparent;
    transition:
        width 0.6s ease,
        background-color 1s ease;
}

.neutral {
    background-color: transparent;
}

.onTrack {
    background-color: var(--mantine-color-teal-5);
}

.approaching {
    background-color: var(--mantine-color-yellow-5);
}

.exceeded {
    background-color: var(--mantine-color-red-5);
}
